<template>

<div>
  <div class="popBg" @click="close"></div>

  <div class="popup fixed">
    <div class="popup__inner fixed z-40 bg-white max-w-2xl rounded w-full">
      <div id="demo" class="">
        <div class="container relative" v-show="panel">
          <div>
            <img ref="clipImg" id="image" :src="url" alt="Picture" style="max-height: 50vh;" class="mx-auto object-contain">
          </div>
          <a type="button" id="clipBtn" @click="crop" class="absolute text-center py-3 cursor-pointer">裁剪</a>
        </div>
        <div class="flex justify-center flex-col items-center h-full py-6" v-if="!panel">
          <div class="show mb-6">
            <div class="picture" :style="'backgroundImage:url('+ headerImage + ')'" v-if="headerImage">
            </div>
            <div class="nonPicture bg-gray-400 relative" v-else>
              <font-awesome-icon :icon="['far', 'user']" class="text-white text-5xl text-center w-full leading-loose absolute" />
            </div>
          </div>
          <div class="flex justify-center btns w-3/4">
            <div class="mx-1">
              <label class="px-8 py-2 rounded text-sm text-NotoSansRegular border border-gray-700 cursor-pointer button-gray">
                <input id="change" style="display:none;" type="file" @change="change" accept="image">
                <font-awesome-icon :icon="['fa', 'photo']" />
                <span v-if="!headerImage">選擇檔案</span>
                <span v-else>重新選擇</span>
              </label>
            </div>
            <div class="mx-1">
              <a class="px-8 py-2 rounded text-sm text-NotoSansRegular border border-gray-700 cursor-pointer button-gray"
                @click.prevent="postImg">
                確定
              </a>
              <a class="px-8 py-2 rounded text-sm text-NotoSansRegular border border-gray-700 cursor-pointer button-gray"
                @click.prevent="close">
                關閉
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>
<script>
// import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
export default {
  name: 'Cropper',
  data () {
    return {
      headerImage: null,
      picValue: null,
      cropper: null,
      croppable: false,
      panel: false,
      url: null,

      fileName: null
    }
  },
  props: {
    userUrl: {
      type: String
    }
  },
  components: {
    // Cropper
  },
  mounted () {
    // this.init()
  },
  watch: {
  },
  methods: {
    // init () {
    //   let self = this
    //   self.headerImage = self.userUrl ? self.userUrl : null
    //   let image = document.getElementById('image')
    //   self.cropper = new Cropper(image, {
    //     aspectRatio: 1,
    //     viewMode: 1,
    //     background: false,
    //     zoomable: false,
    //     minCropBoxWidth: 100,
    //     minCropBoxHeight: 100,
    //     ready () {
    //       self.croppable = true
    //     }
    //   })
    // },
    getObjectURL (file) {
      let url = null
      if (window.createObjectURL) { // basic
        url = window.createObjectURL(file)
      } else if (window.URL) { // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    change (e) {
      let self = this
      let files = e.target.files || e.dataTransfer.files
      self.fileName = e.target.files[0].name
      if (!files.length) return
      self.panel = true
      self.picValue = files[0]

      self.url = self.getObjectURL(self.picValue)
      if (self.cropper) {
        self.cropper.replace(self.url)
      }
      self.panel = true
    },
    crop () {
      let self = this
      self.panel = false
      let croppedCanvas
      let roundedCanvas
      if (!self.croppable) {
        return
      }
      // Crop
      croppedCanvas = self.cropper.getCroppedCanvas()
      // Round
      roundedCanvas = self.getRoundedCanvas(croppedCanvas)

      self.headerImage = roundedCanvas.toDataURL()
      // self.postImg()
    },
    getRoundedCanvas (sourceCanvas) {
      let canvas = document.createElement('canvas')
      let context = canvas.getContext('2d')
      let width = sourceCanvas.width
      let height = sourceCanvas.height

      canvas.width = width
      canvas.height = height

      context.imageSmoothingEnabled = true
      context.drawImage(sourceCanvas, 0, 0, width, height)
      context.globalCompositeOperation = 'destination-in'
      context.beginPath()
      context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true)
      context.fill()

      return canvas
    },
    postImg () {
      let self = this
      self.$emit('setPhoto', self.headerImage)
    },
    close () {
      let self = this
      self.$emit('close', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 50%;
    left: 50%;
    max-height: 70vh;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    transform: translate(-50%, -50%) !important;

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
  .btns {
    bottom: 0;
  }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(0.3);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(.3);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

#demo #clipBtn {
  width: 100%;
  border: 1px solid #434343;
  background: white;
  transition: .3s;
  &:hover {
    background: #434343;
    color: white;
  }
}
#demo .show {
  width: 15em;
  height: 15em;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  border: 1px solid #d5d5d5;
}
#demo .picture {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
#demo .nonPicture {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  .fa-user {
    top: 50%;
    transform: translateY(-50%);
  }
}
#demo .container {
  z-index: 99;
  position: fixed;
  // padding-top: 60px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background:rgba(0,0,0,1);
}
#demo #image {
  max-width: 100%;
}
.cropper-view-box,.cropper-face {
  border-radius: 50%;
}

.cropper-container {
  font-size: 0;
  line-height: 0;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  direction: ltr;
  -ms-touch-action: none;
  touch-action: none
}
.cropper-container img {
  display: block;
  min-width: 0 !important;
  max-width: none !important;
  min-height: 0 !important;
  max-height: none !important;
  width: 100%;
  height: 100%;
  image-orientation: 0deg
}
.cropper-wrap-box,
.cropper-canvas,
.cropper-drag-box,
.cropper-crop-box,
.cropper-modal {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.cropper-wrap-box {
  overflow: hidden;
}
.cropper-drag-box {
  opacity: 0;
  background-color: #fff;
}
.cropper-modal {
  opacity: .5;
  background-color: #000;
}
.cropper-view-box {
  display: block;
  overflow: hidden;
  width: 100%;
  height: 100%;
  outline: 1px solid #39f;
  outline-color: rgba(51, 153, 255, 0.75);
}

.cropper-dashed {
  position: absolute;
  display: block;
  opacity: .5;
  border: 0 dashed #eee
}
.cropper-dashed.dashed-h {
  top: 33.33333%;
  left: 0;
  width: 100%;
  height: 33.33333%;
  border-top-width: 1px;
  border-bottom-width: 1px
}
.cropper-dashed.dashed-v {
  top: 0;
  left: 33.33333%;
  width: 33.33333%;
  height: 100%;
  border-right-width: 1px;
  border-left-width: 1px
}
.cropper-center {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 0;
  height: 0;
  opacity: .75
}
.cropper-center:before,
  .cropper-center:after {
  position: absolute;
  display: block;
  content: ' ';
  background-color: #eee
}
.cropper-center:before {
  top: 0;
  left: -3px;
  width: 7px;
  height: 1px
}
.cropper-center:after {
  top: -3px;
  left: 0;
  width: 1px;
  height: 7px
}
.cropper-face,
.cropper-line,
.cropper-point {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  opacity: .1;
}
.cropper-face {
  top: 0;
  left: 0;
  background-color: #fff;
}
.cropper-line {
  background-color: #39f
}
.cropper-line.line-e {
  top: 0;
  right: -3px;
  width: 5px;
  cursor: e-resize
}
.cropper-line.line-n {
  top: -3px;
  left: 0;
  height: 5px;
  cursor: n-resize
}
.cropper-line.line-w {
  top: 0;
  left: -3px;
  width: 5px;
  cursor: w-resize
}
.cropper-line.line-s {
  bottom: -3px;
  left: 0;
  height: 5px;
  cursor: s-resize
}
.cropper-point {
  width: 5px;
  height: 5px;
  opacity: .75;
  background-color: #39f
}
.cropper-point.point-e {
  top: 50%;
  right: -3px;
  margin-top: -3px;
  cursor: e-resize
}
.cropper-point.point-n {
  top: -3px;
  left: 50%;
  margin-left: -3px;
  cursor: n-resize
}
.cropper-point.point-w {
  top: 50%;
  left: -3px;
  margin-top: -3px;
  cursor: w-resize
}
.cropper-point.point-s {
  bottom: -3px;
  left: 50%;
  margin-left: -3px;
  cursor: s-resize
}
.cropper-point.point-ne {
  top: -3px;
  right: -3px;
  cursor: ne-resize
}
.cropper-point.point-nw {
  top: -3px;
  left: -3px;
  cursor: nw-resize
}
.cropper-point.point-sw {
  bottom: -3px;
  left: -3px;
  cursor: sw-resize
}
.cropper-point.point-se {
  right: -3px;
  bottom: -3px;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  opacity: 1
}
@media (min-width: 768px) {
  .cropper-point.point-se {
    width: 15px;
    height: 15px
  }
}
@media (min-width: 992px) {
  .cropper-point.point-se {
    width: 10px;
    height: 10px
  }
}
@media (min-width: 1200px) {
  .cropper-point.point-se {
    width: 5px;
    height: 5px;
    opacity: .75
  }
}
.cropper-point.point-se:before {
  position: absolute;
  right: -50%;
  bottom: -50%;
  display: block;
  width: 200%;
  height: 200%;
  content: ' ';
  opacity: 0;
  background-color: #39f
}
.cropper-invisible {
  opacity: 0;
}
.cropper-bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
.cropper-hide {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
}
.cropper-hidden {
  display: none !important;
}
.cropper-move {
  cursor: move;
}
.cropper-crop {
  cursor: crosshair;
}
.cropper-disabled .cropper-drag-box,
.cropper-disabled .cropper-face,
.cropper-disabled .cropper-line,
.cropper-disabled .cropper-point {
  cursor: not-allowed;
}
</style>
